/**
 * Present when the component begins animating in.
 */
export const startingStyle = 'data-starting-style';

/**
 * Present when the component is animating out.
 */
export const endingStyle = 'data-ending-style';
